/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Messages(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24.000000000000004'
                width='24.000000000000004'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g>
                    <rect
                        fill='none'
                        height='26'
                        id='canvas_background'
                        width='26'
                        x='-1'
                        y='-1'
                    />
                    <g
                        display='none'
                        height='100%'
                        id='canvasGrid'
                        overflow='visible'
                        width='100%'
                        x='0'
                        y='0'
                    >
                        <rect
                            fill='url(#gridpattern)'
                            height='100%'
                            strokeWidth='0'
                            width='100%'
                            x='0'
                            y='0'
                        />
                    </g>
                </g>
                <g>
                    <g
                        id='svg_18'
                        stroke='null'
                    >
                        <g
                            fill='none'
                            fillRule='evenodd'
                            id='svg_10'
                            transform='matrix(0.7735544447871574,0,0,0.9094840903592045,16.379574302782324,25.116591499885534) '
                        >
                            <g
                                fill={iconColor || '#202020'}
                                id='svg_11'
                                stroke='null'
                            >
                                <g
                                    id='svg_12'
                                    stroke='null'
                                >
                                    <path
                                        d='m6.42456,-26.65927l-24.17564,0c-1.26875,0 -2.30124,1.03248 -2.30124,2.30123l0,15.49511c0,1.26875 1.03249,2.30124 2.30124,2.30124l2.45659,0c0.2217,0 0.42398,0.11975 0.53405,0.31071l1.69112,2.96799c0.30262,0.52916 0.84638,0.85446 1.45646,0.86577l0.03722,0c0.59553,0 1.13767,-0.29939 1.45323,-0.80591l1.91446,-3.05213c0.11328,-0.17963 0.30909,-0.28805 0.52108,-0.28805l14.11306,0c1.26875,0 2.30123,-1.03249 2.30123,-2.30124l0,-15.49345c-0.00161,-1.26875 -1.03409,-2.30127 -2.30284,-2.30127l-0.00002,0zm1.19915,17.79813c0,0.6619 -0.53729,1.19753 -1.19754,1.19753l-14.11305,0c-0.59554,0 -1.13929,0.301 -1.45485,0.80429l-1.91446,3.05213c-0.16506,0.26702 -0.42559,0.28968 -0.53405,0.28813c-0.10519,-0.00169 -0.36574,-0.0373 -0.52109,-0.31079l-1.69111,-2.96798c-0.30586,-0.53567 -0.87713,-0.86905 -1.49371,-0.86905l-2.45498,0.00162c-0.6619,0 -1.19753,-0.53729 -1.19753,-1.19754l-0.00162,-15.49511c0,-0.66191 0.53729,-1.19754 1.19753,-1.19754l24.1773,0c0.66191,0 1.19754,0.53729 1.19754,1.19754l0.00162,15.49677z'
                                        id='svg_16'
                                        stroke='null'
                                    />
                                    <path
                                        d='m2.74777,-21.79929l-16.82083,0c-0.30585,0 -0.55182,0.2476 -0.55182,0.55183c0,0.30586 0.2476,0.55183 0.55182,0.55183l16.82373,0c0.30586,0 0.55183,-0.2476 0.55183,-0.55183c-0.00162,-0.30586 -0.24922,-0.55183 -0.55506,-0.55183l0.00033,0z'
                                        id='svg_15'
                                        stroke='null'
                                    />
                                    <path
                                        d='m2.74777,-17.16136l-16.82083,0c-0.30585,0 -0.55182,0.2476 -0.55182,0.55183c0,0.30586 0.2476,0.55183 0.55182,0.55183l16.82373,0c0.30586,0 0.55183,-0.2476 0.55183,-0.55183c-0.00162,-0.30424 -0.24922,-0.55183 -0.55506,-0.55183l0.00033,0z'
                                        id='svg_14'
                                        stroke='null'
                                    />
                                    <path
                                        d='m2.74777,-12.52509l-16.82083,0c-0.30585,0 -0.55182,0.2476 -0.55182,0.55183c0,0.30586 0.2476,0.55183 0.55182,0.55183l16.82373,0c0.30586,0 0.55183,-0.2476 0.55183,-0.55183c-0.00162,-0.30424 -0.24922,-0.55183 -0.55506,-0.55183l0.00033,0z'
                                        id='svg_13'
                                        stroke='null'
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}